// SellerInfo.jsx
// Component for displaying seller information - Modernized

import React from 'react';
import { COLORS, LAYOUT } from '../../constants';

// Modern SVG Icons
const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const ShieldCheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <polyline points="9,12 12,15 22,6"></polyline>
  </svg>
);

const SellerInfo = ({ seller }) => {
  if (!seller) return null;

  const isVerified = seller.isVerified !== false; // Default to verified for ISU students

  return (
    <div style={modernStyles.sellerSection}>
      <h3 style={modernStyles.sectionTitle}>Seller Information</h3>
      
      <div style={modernStyles.sellerCard}>
        {/* Seller Avatar & Basic Info */}
        <div style={modernStyles.sellerHeader}>
          <div style={modernStyles.avatarContainer}>
            <div style={modernStyles.avatar}>
              <UserIcon />
            </div>
            {isVerified && (
              <div style={modernStyles.verifiedBadge}>
                <ShieldCheckIcon />
              </div>
            )}
          </div>
          
          <div style={modernStyles.sellerDetails}>
            <div style={modernStyles.sellerName}>
              {seller.name || 'RedBird Student'}
            </div>
            <div style={modernStyles.sellerEmail}>
              {seller.email}
            </div>
            {isVerified && (
              <div style={modernStyles.verificationStatus}>
                <ShieldCheckIcon />
                <span>Verified ISU Student</span>
              </div>
            )}
          </div>
        </div>

        {/* Trust Indicators */}
        <div style={modernStyles.trustSection}>
          <div style={modernStyles.trustIndicators}>
            {seller.emailVerified && (
              <div style={modernStyles.trustItem}>
                ✓ ISU Email Verified
              </div>
            )}
            {seller.joinedAt && (
              <div style={modernStyles.trustItem}>
                ✓ Active Since {new Date(seller.joinedAt.seconds * 1000).getFullYear()}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Modern styles
const modernStyles = {
  sellerSection: {
    paddingBottom: LAYOUT.spacing.lg,
    borderBottom: `1px solid ${COLORS.border}`,
  },
  sectionTitle: {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.lg,
  },
  
  // Seller Card
  sellerCard: {
    backgroundColor: COLORS.grayLight,
    borderRadius: LAYOUT.borderRadius.lg,
    padding: LAYOUT.spacing.xl,
    border: `1px solid ${COLORS.border}`,
  },
  
  // Seller Header
  sellerHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: LAYOUT.spacing.lg,
    marginBottom: LAYOUT.spacing.lg,
  },
  avatarContainer: {
    position: 'relative',
  },
  avatar: {
    width: '60px',
    height: '60px',
    backgroundColor: COLORS.primary,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLORS.white,
  },
  verifiedBadge: {
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    width: '20px',
    height: '20px',
    backgroundColor: '#4CAF50',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLORS.white,
    border: `2px solid ${COLORS.white}`,
  },
  sellerDetails: {
    flex: 1,
  },
  sellerName: {
    fontSize: '1.125rem',
    fontWeight: '600',
    color: COLORS.text.primary,
    marginBottom: LAYOUT.spacing.xs,
  },
  sellerEmail: {
    fontSize: '0.875rem',
    color: COLORS.text.secondary,
    marginBottom: LAYOUT.spacing.sm,
  },
  verificationStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: LAYOUT.spacing.xs,
    color: '#4CAF50',
    fontSize: '0.75rem',
    fontWeight: '600',
  },
  
  // Trust Section
  trustSection: {
    marginTop: LAYOUT.spacing.lg,
    paddingTop: LAYOUT.spacing.lg,
    borderTop: `1px solid ${COLORS.border}`,
  },
  trustIndicators: {
    display: 'flex',
    flexDirection: 'column',
    gap: LAYOUT.spacing.sm,
  },
  trustItem: {
    fontSize: '0.875rem',
    color: '#4CAF50',
    fontWeight: '500',
  },
};

export default SellerInfo;